<template>
  <landing-page-customization-container :uri="uri">
    <div
      slot-scope="{ isLoading, landingPageCustomization, errorCaught }"
      class="white-label-redemption-page"
    >
      <redirect
        v-if="errorCaught"
        route-name="Redeem"
      />
      <white-label-printable-reward-link-redemption-page-loading
        v-else-if="isLoading"
      />
      <printable-reward-link-redemption-page
        v-else
        :landing-page-customization="landingPageCustomization"
      />
    </div>
  </landing-page-customization-container>
</template>

<script>
import LandingPageCustomizationContainer from '../customization/LandingPageCustomizationContainer'
import PrintableRewardLinkRedemptionPage from './PrintableRewardLinkRedemptionPage'
import Redirect from '../router/Redirect'
import WhiteLabelPrintableRewardLinkRedemptionPageLoading from './WhiteLabelPrintableRewardLinkRedemptionPageLoading'
export default {
  name: 'WhiteLabelPrintableRewardLinkRedemptionPage',
  components: {
    WhiteLabelPrintableRewardLinkRedemptionPageLoading,
    Redirect,
    PrintableRewardLinkRedemptionPage,
    LandingPageCustomizationContainer
  },
  props: {
    uri: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss">
.white-label-redemption-page {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>
